import { WebSocketStats } from '@/global';
import { create } from 'zustand';

export interface BroadCast {
  status: WebSocketStats;
  socket: WebSocket | null;
  socketConnected: boolean;
  isWaitingMasterConfirmation: boolean;
  /** Sisbov que o slave acabou de enviar e está aguardando confirmação do master */
  pendingSisbov: number | null;
  /** Brinco eletrônico que o slave enviou e aguarda confirmação (usado quando não há SISBOV) */
  pendingElectronic: string | null;

  setSocket: (socket: WebSocket | null) => void;
  setStatus: (props: WebSocketStats) => void;
  setSocketConnected: (connected: boolean) => void;
  setIsWaitingMasterConfirmation: (waiting: boolean) => void;
  setPendingSisbov: (sisbov: number | null) => void;
  setPendingElectronic: (electronic: string | null) => void;
}

export const useBroadCast = create<BroadCast>()((set) => ({
  status: {
    port: null,
    isRunning: false,
    connectedClients: 0,
    localIPs: [],
    publicUrl: null
  },
  socket: null,
  socketConnected: false,
  isWaitingMasterConfirmation: false,
  pendingSisbov: null,
  pendingElectronic: null,

  setStatus: (props: WebSocketStats) => set(() => ({ status: props })),
  setSocket: (socket: WebSocket | null) => set(() => ({ socket })),
  setSocketConnected: (connected: boolean) => set(() => ({ socketConnected: connected })),
  setIsWaitingMasterConfirmation: (waiting: boolean) => set(() => ({ isWaitingMasterConfirmation: waiting })),
  setPendingSisbov: (sisbov: number | null) => set(() => ({ pendingSisbov: sisbov })),
  setPendingElectronic: (electronic: string | null) => set(() => ({ pendingElectronic: electronic }))
}));
